import React, { useRef, useEffect } from 'react'

import ReactQuill from 'react-quill-new'
import 'react-quill-new/dist/quill.snow.css'

const Editor = {}

/*
 * Quill modules to attach to editor
 * See https://quilljs.com/docs/modules/ for complete options
 */
Editor.modules = {
	toolbar: [
		[{ header: '1' }, { header: '2' }, { font: [] }],
		[{ size: [] }],
		['bold', 'italic', 'underline', 'strike', 'blockquote'],
		[{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
		['link'],
		['clean'],
	],
	clipboard: {
		// toggle to add extra line breaks when pasting HTML:
		matchVisual: false,
	},
}
/*
 * Quill editor formats
 * See https://quilljs.com/docs/formats/
 */
Editor.formats = [
	'header',
	'font',
	'size',
	'bold',
	'italic',
	'underline',
	'strike',
	'blockquote',
	'list',
	'bullet',
	'indent',
	'link',
]

export default function TextEditor(props) {
	const quillRef = useRef(null)

	useEffect(() => {
		if (quillRef.current) {
			try {
				const editorNode = quillRef.current.getEditor().root // Get the actual DOM node of the editor
				const observer = new MutationObserver((mutations) => {
					// Handle mutations - this prevents the MutationObserver error
					mutations.forEach((_mutation) => {
						// Optional: Add any custom mutation handling here if needed
					})
				})

				// Only observe if editorNode is a valid DOM node
				if (editorNode && editorNode.nodeType === Node.ELEMENT_NODE) {
					observer.observe(editorNode, { childList: true, subtree: true })
				}

				return () => observer.disconnect() // Clean up on unmount
			} catch (error) {
				// Silently handle any initialization errors
				console.warn('Quill editor initialization warning:', error.message)
			}
		}
	}, [])

	return (
		<ReactQuill
			ref={quillRef}
			{...props}
			style={{ opacity: props?.disabled ? 0.7 : 1, pointerEvents: props?.disabled ? 'none' : 'all' }}
			theme="snow"
			modules={Editor.modules}
			formats={Editor.formats}
		/>
	)
}
